import { LOAD_RESOURCES } from '../../constant';

const resources = (state = [], action) => {
  if (action.type === LOAD_RESOURCES) return action.payload;
  else return state;
};

export default resources;
